module.exports = __webpack_public_path__ + "img/banner.de67e0f8.jpg";